import type { FC } from "react";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

export const BLOG_CONTACT_FOOTER_MARKER = "<!-- blog-contact-footer -->";

const WHATSAPP_HREF = "https://wa.me/31639202608";
const APPOINTMENT_HREF =
  "https://cal.com/team/opensourcelinic/medical-coaching";

export const BlogContactFooter: FC = () => {
  return (
    <Typography
      color="text.secondary"
      sx={{ fontStyle: "italic", mb: 3, mt: 4 }}
      variant="body2"
    >
      Questions about applications, connection options, technical assistance,
      help with creating or setting up an open-source loop, choosing a pump,
      choosing a loop, choosing a sensor, watch to a toaster, cannot fine-tune
      basal rate, struggling with bolus timing or can&apos;t find your cat,
      etc...? Send us a message on{" "}
      <Link href={WHATSAPP_HREF} rel="noreferrer" target="_blank">
        WhatsApp
      </Link>{" "}
      or{" "}
      <Link
        fontWeight={500}
        href={APPOINTMENT_HREF}
        rel="noopener noreferrer"
        target="_blank"
      >
        book a free appointment
      </Link>
      .
    </Typography>
  );
};
